import { enrichConvertersRegistry } from '../../utils/convertersRegistry'
import { filterConverterMap } from './filterPropsToCss'

/**
 * Enriches the converters registry with all filter-related style property converters.
 * Filter converters handle filter types, styles, weights, and other filter properties.
 */
export function enrichFilterConverters(): void {
	// Register all font converters
	Object.entries(filterConverterMap).forEach(([key, converter]) => {
		enrichConvertersRegistry(key, converter)
	})
}
